
import { Service } from '@/components/api';
import Cookies from 'js-cookie';
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {},
})
export default class HomeView extends Vue {

	services : Service[] = []
	mounted(){

		const token = Cookies.get('API_TOKEN')

		if(!token)
			this.$router.push("/login")
		
		this.getMenu()
	}

	async getMenu(){

		try {
			
			const response = await this.$store.getters.client.get('/me')

			this.services = response.data.services

		} catch(e){
			console.error(e)
			setTimeout(this.getMenu, 5 * 100)
		}
	}
}
